import isEmpty from 'lodash/isEmpty';
import matches from 'validator/lib/matches';

const isHour = (value) => {
    if (isEmpty(value)) {
        return true;
    }

    return matches(value, /^([01]?[0-9]|2[0-3]):([0-9]|[0-5][0-9])$/i);
};

export {
    isHour
};
